import { Component, Input, OnInit } from '@angular/core';
import { ReportCompanyApp } from 'app/models/report-company-app.model';
import { MicroserviceOperation, ReportRolesPermission } from 'app/models/report-roles-permission.model';
import { ReportUserCompanyApp } from 'app/models/report-user-company-app.model';
import { Microservice, ReportUserRoles } from 'app/models/report-user-roles.model';
import { CompanyAppTree, ReportCompanyAppTree } from 'app/models/report-company-app-tree.model';
import { TreeNode } from 'primeng/api';
import { ReportUserCompanyAppTree, UserCompanyAppTree } from 'app/models/report-user-company-app-tree.model';
import { ReportUserRolesTree, UserRolesTree } from 'app/models/report-user-roles-tree.model';
import { ReportRolesPermissionTree, RolesPermissionTree } from 'app/models/report-roles-permission-tree.model';

@Component({
  selector: 'app-view-report',
  templateUrl: './view-report.component.html',
  styleUrls: ['./view-report.component.css']
})
export class ViewReportComponent implements OnInit {

  @Input() showCompanyApp: boolean = false;
  @Input() showUserCompanyApp: boolean = false;
  @Input() showUserRoles: boolean = false;
  @Input() showRolesPermission: boolean = false;
  @Input() data;

  reportCompanyAppTree: ReportCompanyAppTree[] = [];
  reportUserCompanyAppTree: ReportUserCompanyAppTree[] = [];
  reportUserRolesTree: ReportUserRolesTree[] = [];
  reportRolesPermissionTree: ReportRolesPermissionTree[] = [];

  reportCompanyApp: ReportCompanyApp[];
  reportUserCompanyApp: ReportUserCompanyApp[];
  reportUserRoles: ReportUserRoles[];
  reportRolesPermission: ReportRolesPermission[] = [];

  constructor() { }

  ngOnInit() {

    if (this.showCompanyApp) {
      this.reportCompanyApp = this.data as ReportCompanyApp[];
      this.generateReportCompanyApp(this.reportCompanyApp);
    }

    if (this.showUserCompanyApp) {
      this.reportUserCompanyApp = this.data as ReportUserCompanyApp[];
      this.generateReportUserCompanyApp(this.reportUserCompanyApp);
    }

    if (this.showUserRoles) {
      this.reportUserRoles = this.data as ReportUserRoles[];
      this.generateReportUserRoles(this.reportUserRoles);
    }

    if (this.showRolesPermission) {
      let rolesPermission: ReportRolesPermission = this.data;
      this.reportRolesPermission.push(rolesPermission);
      this.generateReportRolesPermission(this.reportRolesPermission);
    }
  }

  generateReportCompanyApp(reportData: ReportCompanyApp[]) {
    reportData.forEach( c => {
      let final: ReportCompanyAppTree = {};
      let data: CompanyAppTree = {
        company: c.name
      };
      let children: ReportCompanyAppTree[] = [];
      if (c.reportApplicationList !=null) {
        c.reportApplicationList.forEach( r => {
          let appDataTree: ReportCompanyAppTree = {};
          let appData: CompanyAppTree = {
              application: r.name,
              ms_base_url: r.ms_base_url
          };
          let appChildren: ReportCompanyAppTree[] = [];
          appDataTree.data = appData;
          if (r.userDtoList != null) {
            r.userDtoList.forEach( u => {
              let userDataTree: ReportCompanyAppTree = {};
              let userData: CompanyAppTree = {
                id_user: u.id.toString(),
                login: u.login
              };
              userDataTree.data = userData;
              appChildren.push(userDataTree);
            })
            appDataTree.children = appChildren;
          }
          children.push(appDataTree);
        });
      }
      final.data = data;
      final.children = children;
      this.reportCompanyAppTree.push(final);
    });
  }

  generateReportUserCompanyApp(reportData: ReportUserCompanyApp[]) {
    reportData.forEach(u => {
      let final: ReportUserCompanyAppTree = {};
      let data: UserCompanyAppTree = {
        id_user: u.id.toString(),
        login: u.login,
        role_description: u.role_description,
      };
      let children: ReportUserCompanyAppTree[] = [];
      if (u.companies != null) {
        u.companies.forEach(r => {
          let companyDataTree: ReportUserCompanyAppTree = {}
          let companyData: UserCompanyAppTree = {
            company: r.company_name,
          };
          let companyChildren: ReportUserCompanyAppTree[] = []
          companyDataTree.data = companyData
          if (r.applications != null) {
            r.applications.forEach(app => {
              let appDataTree: ReportUserCompanyAppTree = {};
              let appData: UserCompanyAppTree = {
                application: app.application_name,
                application_description: app.application_description
              }
              appDataTree.data = appData;
              companyChildren.push(appDataTree);
            })
            companyDataTree.children = companyChildren;
          }
          children.push(companyDataTree);
        })
      }
      final.data = data;
      final.children = children;
      this.reportUserCompanyAppTree.push(final);
    });
  }

  generateReportUserRoles(reportData: ReportUserRoles[]) {
    reportData.forEach( c => {
      let final: ReportUserRolesTree = {};
      let data: UserRolesTree = {
        id_user: c.id,
        login: c.login,
        email: c.email
      };
      let children: ReportUserRolesTree[] = [];
      if (c.ms !=null) {

        let microservices: Microservice[] = [];
        let arr = Object.keys(c.ms).map(function (key) {
          let ms: Microservice = {
            ms_name: key,
            roles: c.ms[key]
          };
          microservices.push(ms);
          return c.ms[key];
        });

        microservices.forEach( r => {
          let appDataTree: ReportUserRolesTree = {};
          let appData: UserRolesTree = {
              ms: r.ms_name
          };
          let appChildren: ReportUserRolesTree[] = [];
          appDataTree.data = appData;
          if (r.roles != null) {
            r.roles.forEach( u => {
              let userDataTree: ReportUserRolesTree = {};
              let userData: UserRolesTree = {
                role_id: u.role_id,
                descr: u.descr,
                application_name: u.application_name
              };
              userDataTree.data = userData;
              appChildren.push(userDataTree);
            })
            appDataTree.children = appChildren;
          }
          children.push(appDataTree);
        });
      }
      final.data = data;
      final.children = children;
      this.reportUserRolesTree.push(final);
    });
  }

  generateReportRolesPermission(reportData: ReportRolesPermission[]) {
    reportData.forEach( c => {
      let final: ReportRolesPermissionTree = {};
      let data: RolesPermissionTree = {
        company_id: c.company_id
      };
      let children: ReportRolesPermissionTree[] = [];
      if (c.ms !=null) {

        let microservices: MicroserviceOperation[] = [];
        let arr = Object.keys(c.ms).map(function (key) {
          let ms: MicroserviceOperation = {
            ms_name: key,
            roles: c.ms[key]
          };
          microservices.push(ms);
          return c.ms[key];
        });

        microservices.forEach( r => {
          let appDataTree: ReportRolesPermissionTree = {};
          let appData: RolesPermissionTree = {
              ms: r.ms_name
          };
          let appChildren: ReportRolesPermissionTree[] = [];
          appDataTree.data = appData;
          if (r.roles != null) {
            r.roles.forEach( u => {
              let userDataTree: ReportRolesPermissionTree = {};
              let userData: RolesPermissionTree = {
                role_id: u.role_id,
                descr: u.descr
              };

              let operationChildren: ReportRolesPermissionTree[] = [];
              if (u.operations != null) {
                u.operations.forEach( op => {
                  let operationDataTree: ReportRolesPermissionTree = {};
                  let operationData: RolesPermissionTree = {
                    operation_id: op.operation_id,
                    operation: op.operation,
                    type: op.type
                  };
                  operationDataTree.data = operationData;
                  operationChildren.push(operationDataTree);
                });
              }
              userDataTree.data = userData;
              userDataTree.children = operationChildren;
              appChildren.push(userDataTree);
            })
            appDataTree.children = appChildren;
          }
          children.push(appDataTree);
        });
      }
      final.data = data;
      final.children = children;
      this.reportRolesPermissionTree.push(final);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/views/administration/report-user/view-report/view-report.component.ts